module.exports = __webpack_public_path__ + "assets/b7fac12d679004047dddc0650e8856d4.mp3";